<!--我的证书-->
<template>
    <div class="studio_nav_content">
        <div class="page-mode">
            <div class="sec-title">
                <div class="bar"></div>
                <div class="name">我的证书</div>
            </div>
            <div class="cert-body">
                <div class="cert-list" v-if="certList.length > 0">
                    <el-image v-for="(item, index) in certList" :initial-index="index" fit="cover"
                              :preview-src-list="certList" class="cert-img"
                              :src="item" alt="" />
                </div>
                <el-empty style="padding-top: 10vh;" v-if="certList.length === 0" :image-size="160"
                          description="暂无证书" />
            </div>
        </div>
    </div>
</template>

<script>
import { userCerts } from "@/api/admin/public";

export default {
    name: "myCerts",
    components: {},
    data() {
        return {
            certList: [],
        };
    },
    created() {
        this.getUserCerts();
    },
    methods: {
        getUserCerts() {
            this.certList = []
            userCerts().then(reson => {
                reson.data.data.forEach(e => {
                    this.certList.push(e.certUrl)
                })
            })
        },
    }
};
</script>
<style scoped>
.studio_nav_content{
    width: 100%;
}
.page-mode{
    width: 100%;
    height: calc(100vh - 182px);
    background-color: #fff;
    border-radius: 16px;
    box-sizing: border-box;
    padding: 24px;
    overflow-y: auto;
}
/*区块标题*/
.sec-title{
    display: flex;
    align-items: center;
    height: 30px;
    margin-bottom: 16px;
    .bar{
        width: 4px;
        height: 16px;
        background: #ff7f2e;
        border-radius: 2px;
        margin-right: 8px;
    }
    .name{
        font-size: 16px;
        font-weight: bold;
        color: #333;
    }
}
/*证书列表*/
.cert-list{
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
}
.cert-img{
    width: 240px;
    height: 170px;
    object-fit: cover;
    border-radius: 8px;
    border: 1px solid #f0f0f0;
    cursor: pointer;
}
</style>
